import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import registerServiceWorker from './registerServiceWorker'
import AppRouter from './routers/AppRouter'
import { ToastProvider } from "./components/toastManager/ToastManager";

// Create a root
const root = createRoot(document.getElementById('root'));

// Render your app
root.render(
    <ToastProvider>
        <AppRouter />
    </ToastProvider>
);

registerServiceWorker()